import React, { useEffect, useState } from 'react';
import { container } from 'tsyringe';
import { ChatService } from '../../../services/chat-service';
import { useSharedState } from '../../../utils/helpers';

import './RetryAfter.scss'

export interface RetryAfterProps {
  children?: React.ReactNode
}

const RetryAfter = (props: RetryAfterProps) => {

  const [chatService] = useState(container.resolve(ChatService));

  const [ retryAfterSeconds, setRetryAfterSeconds ] = useSharedState(chatService.retryAfterSeconds$);
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {

    if (!isNaN(retryAfterSeconds) && retryAfterSeconds > 0) {
      const val = Math.ceil((1*retryAfterSeconds) -1);
      setSeconds(val);
      setTimeout(() => {
        setRetryAfterSeconds(val);
      }, 1000);
    }
  }, [retryAfterSeconds])

  return (
    <>
    { seconds <= 0 ?
      <>{props.children}</>
      :
      <div className='rate-limited'>Too many messages being sent right now. Chat will resume in {seconds + 1}s ...</div>
    }
    </>
  )
}

export default RetryAfter;
